export const links = [
  {
    route: '/my-ads',
    label: 'آگهی‌های من',
    icon: 'icon-namespeaker-2',
  },
  {
    route: '/my-favourite-adds',
    label: 'مورد علاقه ها',
    icon: 'icon-namefavourite',
  },
  {
    route: '/my-credits',
    label: 'اعتبارهای من',
    icon: 'icon-namedollardayerei',
  },
  {
    route: '/my-orders',
    label: 'سفارشات من',
    icon: 'icon-nameReceipt-bill',
  },
  {
    route: '/my-accesses',
    label: 'دسترسی‌های من',
    icon: 'icon-namekey',
  },
  {
    route: '/backup',
    label: 'پشتیبانی',
    icon: 'icon-namesupport',
  },
  {
    route: '/rules',
    label: 'قوانین و مقررات',
    icon: 'icon-nameScales',
  },
];
